module.exports = __webpack_public_path__ + "static/media/skin.ce166353.png";